import { getStatusColor, getStatusForeColor, startCase } from '@/utils';
import { DataUsage as DataUsageIcon } from '@mui/icons-material';
import {
  Avatar,
  Box,
  ListItemButton,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { format } from 'date-fns';

export function ObjectiveListItem({ item, feature, ...props }) {
  const startTime = new Date(feature.properties.startTime);
  const endTime = new Date(feature.properties.endTime);

  return (
    <ListItemButton
      {...props}
      dense
      disableGutters
      sx={
        item
          ? {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: `${item.size}px`,
              transform: `translateY(${item.start}px)`,
              px: 1,
            }
          : { px: 1 }
      }
    >
      <Box sx={{ pr: 1 }}>
        <Tooltip title={startCase(feature.properties?.status)} placement="top">
          <Avatar
            sx={{
              color: getStatusForeColor(feature.properties?.status),
              bgcolor: getStatusColor(feature.properties.status),
              borderColor: getStatusForeColor(feature.properties?.status),
              borderWidth: 2,
              borderStyle: 'solid',
            }}
          >
            <DataUsageIcon />
          </Avatar>
        </Tooltip>
      </Box>
      <ListItemText
        primary={feature.properties.title}
        secondary={`${format(startTime, 'dd/MM/yyyy')} - ${format(
          endTime,
          'dd/MM/yyyy',
        )}`}
        slotProps={{
          primary: { noWrap: true },
          secondary: { noWrap: true },
        }}
      />
    </ListItemButton>
  );
}
